import * as React from 'react';
import PropTypes from 'prop-types';

const SvgAchievementsBadgeNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="achievements_badge_normal_xsmall_svg__a">
        <path d="M0 0h16v16H0z" />
      </clipPath>
      <g clipPath="url(#achievements_badge_normal_xsmall_svg__a)" fill="">
        <path d="M8 0L2.55 3v6L5 10.35v5.68l3-1.81 2.99 1.81v-5.68L13.45 9V3zm1.995 14.26L8 13.06l-2 1.2V10.9L8 12l1.995-1.1zm2.455-5.85L8 10.86 3.55 8.41V3.59L8 1.14l4.45 2.45z" />
        <path d="M8 2.29L4.55 4.18v3.61L8 9.69l3.45-1.9V4.18zm2.45 4.91L8 8.55 5.55 7.2V4.78L8 3.43l2.45 1.35z" />
      </g>
    </svg>
  )
);
SvgAchievementsBadgeNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgAchievementsBadgeNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgAchievementsBadgeNormalXsmall;
